import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import "./DateSelect.css";
import styled from "styled-components";
import ko from "date-fns/locale/ko";
import theme from "../../../theme";
import Arrow from "./Arrow";
import { useDispatch } from "react-redux";
import { setSchedule } from "../../../modules/form";

const Container = styled.div`
  display: ${(props) => (props.isVisible ? "block" : "none")};
  position: absolute;
  z-index: 10;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: #ffffff;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0px;
`;

const Span = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #5b5555;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const CalendarContainer = styled.div``;

const HeaderContainer = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const ArrowButton = styled.button`
  margin: 0px 30px;
  font-size: 20px;
  background-color: transparent;
  border: none;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 8px;
  width: 100%;
  height: 64px;
  font-family: Spoqa Han Sans Neo;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #7d7878;
`;

const ButtonNext = styled.button`
  border: none;
  background-color: ${(props) => `${props.disabled ? "#E2E2E2" : "#FF8450"}`};
  color: ${(props) => `${props.disabled ? "#B6B3B3" : "white"}`};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;
  height: 100%;
  font-family: Spoqa Han Sans Neo;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

const ButtonPrev = styled.button`
  border: none;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28%;
  height: 100%;
`;

const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: absolute;
  font-size: 1.3rem;
  top: 14px;
  color: ${theme.colors.black};
  right: 5px;
`;

const CalendarModal = ({ isVisible, closeModal }) => {
  const dispatch = useDispatch();

  const MyContainer = ({ className, children }) => (
    <CalendarContainer className={className}>{children}</CalendarContainer>
  );
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const addStartDate = () =>
    dispatch(setSchedule("startDate", convertDate(startDate)));
  const addEndDate = () =>
    dispatch(setSchedule("endDate", convertDate(endDate)));

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const isValid = () => {
    if (startDate && endDate) return true;
    return false;
  };

  const onSubmit = () => {
    addStartDate();
    addEndDate();
    closeModal();
  };

  const convertDate = (date) => {
    const offset = date.getTimezoneOffset();
    const newDate = new Date(date.getTime() - offset * 60 * 1000);
    return newDate.toISOString().split("T")[0];
  };

  const formatDate = (dateInput) => {
    const date = new Date(dateInput);
    const monthIndex = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}년 ${monthIndex}월`;
  };

  return (
    <Container isVisible={isVisible}>
      <Wrapper>
        <HeaderContainer>
          <CloseButton onClick={closeModal}>X</CloseButton>
          <Span>돌봄 날짜 선택</Span>
        </HeaderContainer>
        <ReactDatePicker
          minDate={new Date()}
          onChange={onChange}
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          inline
          selectsRange
          locale={ko}
          popperModifiers={{ preventOverflow: { enabled: true } }}
          popperPlacement="auto"
          calendarContainer={MyContainer}
          disabledKeyboardNavigation
          renderCustomHeader={({
            date,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => {
            return (
              <Header>
                <ArrowButton
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  <Arrow direction="left" />
                </ArrowButton>
                <HeaderTitle>{formatDate(date)}</HeaderTitle>
                <ArrowButton
                  disabled={nextMonthButtonDisabled}
                  onClick={increaseMonth}
                >
                  <Arrow direction="right" />
                </ArrowButton>
              </Header>
            );
          }}
        />
        <FooterContainer>
          <ButtonPrev onClick={closeModal}>이전</ButtonPrev>
          <ButtonNext disabled={!isValid()} onClick={onSubmit}>
            다음
          </ButtonNext>
        </FooterContainer>
      </Wrapper>
    </Container>
  );
};

export default CalendarModal;
